import {
  MANAGEMENT_OVERALL_STATUS_OPTIONS,
  MANAGEMENT_OVERALL_STATUS_VALUES,
} from '../../../../../../core/entities/entryManagements/constants';
import type {ManagementOverAllStatusType} from '../../../../../../core/entities/entryManagements/schema';
import {cn} from '../../../../../../lib/classname';

export const EntryStatusLabel = ({
  hasCompletedEntry,
}: {hasCompletedEntry: boolean}) => {
  if (hasCompletedEntry) {
    return null;
  }

  return (
    <div className="flex items-center justify-center text-xs text-primary border border-primary rounded-full px-8 py-[2px] whitespace-nowrap">
      未エントリー
    </div>
  );
};

export const OverallStatusLabel = ({
  overallStatus,
}: {overallStatus: ManagementOverAllStatusType}) => {
  const label = MANAGEMENT_OVERALL_STATUS_OPTIONS.find(
    (option) => option.value === overallStatus,
  )?.label;

  return (
    <div
      className={cn(
        'w-full flex items-center justify-center text-xs text-white rounded-full px-8 py-[2px]',
        {
          'bg-primary':
            overallStatus === MANAGEMENT_OVERALL_STATUS_VALUES.active,
          'bg-success-1':
            overallStatus === MANAGEMENT_OVERALL_STATUS_VALUES.completed,
          'bg-black-3':
            overallStatus === MANAGEMENT_OVERALL_STATUS_VALUES.archived ||
            overallStatus === MANAGEMENT_OVERALL_STATUS_VALUES.rejected,
        },
      )}
    >
      {label}
    </div>
  );
};
